const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const scrollToHash = (hash) => {
  if (!hash || hash === "#") {
    return false;
  }

  const target = document.querySelector(hash);

  if (!target) {
    return false;
  }

  target.scrollIntoView({
    behavior: prefersReducedMotion ? "auto" : "smooth",
    block: "start",
  });

  return true;
};

document.addEventListener("click", (event) => {
  const link = event.target.closest('a[href^="#"]');

  if (!link) {
    return;
  }

  const hash = link.getAttribute("href");

  if (!scrollToHash(hash)) {
    return;
  }

  event.preventDefault();
  window.history.pushState(null, "", hash);
});

if (window.location.hash) {
  window.requestAnimationFrame(() => {
    scrollToHash(window.location.hash);
  });
}
